module.exports = __webpack_public_path__ + "static/img/job-2.f1f5ee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/job-2.png
// module id = vw0H
// module chunks = 2